import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Permission } from '../../data/model/permission';
import { User, UserTableVisualization } from '../../data/model/user';
import { UserPortalGroup } from '../../data/model/user-portal-group';
import { SharedModule } from '../../shared/shared.module';
import { AppActions, AppSelectors } from '../../store/app-store';
import { environment } from '../../../environments/environment.api';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { NavigationMenuComponent } from '../navigation-menu/navigation-menu.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SharedModule, UserMenuComponent, NavigationMenuComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent  {
  @Input() group!: UserPortalGroup[] | null;

  public user$: Observable<User | null> = this.store.select(AppSelectors.selectUser);
  public viewPermission$: Observable<Permission[] | undefined | null> = this.store.select(
    AppSelectors.selectViewPermssions
  );
  viewModules$: Observable<UserTableVisualization[]> =this.store.select(
    AppSelectors.selectViewModules
  );

  public getGroup(groups: UserPortalGroup[] | null) {
    if(!groups) return
    return groups[0]?.group_item?.custom_logo
  }

  subscription!: Subscription;


  constructor(private store: Store) {}

  setUrl(){
    if(!this.group) return
    if(this.group[0]?.group_item?.custom_logo){
      return `${environment.apiUrl}/${this.group[0]?.group_item.custom_logo}`
    } else {
      return "/../assets/images/logo-colori.png"//new_logo_wt_400x138_01.png"
    }
  }
  public toggleMenu() {
    this.store.dispatch(AppActions.toggleNav());
  }
}
